module.exports = __webpack_public_path__ + "static/media/scan_detail_macbook_mockup.4ea6d929.svg";